import React, { Component } from "react";
import client from "@culturehq/client";
import { ActionButton, Form, Modal, SubmitButton, Success, TextField } from "@culturehq/components";

import { useProfile } from "app/context";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import PageHeader from "components/display/PageHeader";
import ChqModal from "components/common/ChqModal";

class MessageGuestsForm extends Component {
  state = { error: false, success: false };

  componentDidMount() {
    this.componentIsMounted = true;
  }

  componentWillUnmount() {
    this.componentIsMounted = false;
  }

  handleSubmit = async ({ body }) => {
    this.setState({ error: null });

    try {
      const { event: { id: eventId } } = this.props;
      await client.messageEventGuests({ body, eventId });

      if (this.componentIsMounted) {
        this.setState({ success: true });
      }
    } catch (error) {
      if (this.componentIsMounted) {
        this.setState({ error });
      }
    }
  };

  render() {
    const { error, success } = this.state;

    if (success) {
      return <Success><Trans>Message Sent!</Trans></Success>;
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        {error && <ErrorMessage error={error} />}

        <TextField name="body" required>
          <Trans>Message</Trans>
        </TextField>
        <SubmitButton primary fillParent>
          {submitting => (submitting ? t("Submitting...") : t("Message Guests"))}
        </SubmitButton>
      </Form>
    );
  }
}

const MessageGuests = ({ event }) => {
  const { profile } = useProfile();

  if (!event.isUserHostOrAdmin(profile)) {
    return null;
  }

  return (
    <ChqModal
      trigger={onTrigger => (
        <ActionButton icon="envelope" onClick={onTrigger}>
          <Trans>Message Guests</Trans>
        </ActionButton>
      )}
      width="narrow"
    >
      <Modal.Heading>
        <Trans>Message Guests</Trans>
      </Modal.Heading>
      <Modal.Body>
        <PageHeader title={t("Message Guests")}>
          <Trans>
            Would you like to send a note to event guests? All invited guests
            will receive your note via email and as a platform notification
            (provided they have not RSVP&#39;d &#39;No&#39;).
          </Trans>
        </PageHeader>
        <MessageGuestsForm event={event} />
      </Modal.Body>
    </ChqModal>
  );
};

export default MessageGuests;
